import React from 'react';
import { Grid, Header } from 'semantic-ui-react';

import { clienteApi } from 'src/api';
import { Contexto } from 'src/contexto';
import { HeaderNombreDeCurso } from 'src/modulos/Horarios/componentes';
import { compararNombresConApellidosPrimero } from 'src/utilidades';
import { DetallesDelCurso } from '../../tipos';
import { ClaseActual } from './ClaseActual';
import { ListaDeAlumnos } from './ListaDeAlumnos';
import { ClaseDTO } from './tipos';

type Props = Readonly<{
    detalleDelCurso: DetallesDelCurso | undefined;
    actualizarDetalle: () => Promise<DetallesDelCurso>;
}>;

type State = Readonly<{
    cargando: boolean;
    clase?: ClaseDTO;
    numeroActual?: number;
}>;

export class AsistenciaPrevia extends React.Component<Props, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = {
        cargando: true,
    };

    public componentDidMount() {
        this.setState({ cargando: true });
        this.obtenerClase()
            .then(() => this.setState({ cargando: false }))
            .catch();
    }

    public render() {
        const { detalleDelCurso } = this.props;
        const { cargando, clase } = this.state;

        if (!detalleDelCurso || cargando || !clase) return null;

        return (
            <div>
                <HeaderNombreDeCurso curso={detalleDelCurso} />

                <ClaseActual
                    claseActual={this.state.numeroActual ?? clase.numeroDeClase}
                    claseMaxima={clase.numeroDeClaseActual}
                    fecha={clase.fecha}
                    alCambiarAClase={this.cambiarAClaseNumero}
                    alPresionarAtras={() => {
                        const numero = (this.state.numeroActual ?? clase.numeroDeClase) - 1;
                        this.cambiarAClaseNumero(numero);
                    }}
                    alPresionarAdelante={() => {
                        const numero = (this.state.numeroActual ?? clase.numeroDeClase) + 1;
                        this.cambiarAClaseNumero(numero);
                    }}
                />

                <Grid centered>
                    <Grid.Column computer={10} mobile={16}>
                        {clase.asistencias ? (
                            <ListaDeAlumnos asistencias={clase.asistencias} />
                        ) : (
                            <Header>Esta clase no tiene asistencia registrada.</Header>
                        )}
                    </Grid.Column>
                </Grid>
            </div>
        );
    }

    private readonly cambiarAClaseNumero = (numero: number) => {
        const { clase } = this.state;
        if (!clase) return;

        const numeroActual = Math.min(Math.max(numero, 1), clase.numeroDeClaseActual);

        this.setState({ numeroActual });
        this.obtenerClase(numeroActual).catch();
    };

    private async obtenerClase(numeroDeClase?: number) {
        try {
            const curso = this.props.detalleDelCurso ?? (await this.props.actualizarDetalle());

            const clase = await clienteApi.ejecutar('claseDelCurso', {
                idCurso: curso.id,
                numeroDeClase,
            });

            if (clase.asistencias) {
                clase.asistencias.sort((a, b) =>
                    compararNombresConApellidosPrimero(a.nombre, b.nombre),
                );
            }

            this.setState({
                clase,
                numeroActual: clase.numeroDeClase,
            });
        } catch (error) {
            this.context.mostrarModalError(error);
            this.setState({
                clase: undefined,
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/modulos/Horarios/DetalleDelCurso/Asistencia/AsistenciaPrevia/index.tsx